(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('react')) :
  typeof define === 'function' && define.amd ? define('@fdn/modal', ['react'], factory) :
  (global = global || self, global['@fdn/modal'] = factory(global.React));
}(this, (function (React) { 'use strict';

  React = React && Object.prototype.hasOwnProperty.call(React, 'default') ? React['default'] : React;

  var Desktop = function Desktop(_ref) {
    var element_id = _ref.element_id,
        element_id_close = _ref.element_id_close,
        show = _ref.show,
        on_click = _ref.on_click,
        closable = _ref.closable,
        background_image = _ref.background_image,
        width = _ref.width,
        bottom = _ref.bottom,
        top = _ref.top,
        children = _ref.children;

    if (!show) {
      return null;
    } else {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "fdn-bg-filter-modal",
        onClick: closable ? on_click : function () {}
      }), /*#__PURE__*/React.createElement("div", {
        id: element_id,
        className: "fdn-modal"
      }, /*#__PURE__*/React.createElement("div", {
        className: "fdn-modal-header"
      }, closable && /*#__PURE__*/React.createElement("span", {
        id: element_id_close,
        onClick: closable ? on_click : function () {}
      }, "\xD7")), /*#__PURE__*/React.createElement("div", {
        className: "fdn-modal-content"
      }, children)), /*#__PURE__*/React.createElement("style", null, "\n            .fdn-bg-filter-modal {\n              display: block;\n              width: 100%;\n              height: 100%;\n              top: 0;\n              position: fixed;\n              background-color: rgb(0, 0, 0);\n              background-color: rgba(0, 0, 0, 0.4);\n              z-index: 998;\n            }\n            .fdn-modal {\n              position: fixed;\n              z-index: 999;\n              width: ".concat(width ? width : '870px', ";\n              background-image: url(").concat(background_image, ");\n              background-color: #fff;\n              background-repeat: no-repeat;\n              background-size: cover;\n              padding: 20px;\n              border: 1px solid #888;\n              top: ").concat(top ? top : '50%', ";\n              left: 50%;\n              margin-right: -50%;\n              transform: translate(-50%, -50%);\n              bottom: ").concat(bottom ? bottom : 'unset', ";\n              -webkit-animation-name: animatezoom;\n              -webkit-animation-duration: 0.4s;\n              animation-name: animatezoom;\n              animation-duration: 0.4s;\n            }\n            .fdn-modal-header {\n              position: relative;\n              width: 100%;\n              height: 15px;\n            }\n            .fdn-modal-header span {\n              position: absolute;\n              color: #000;\n              right: 0;\n              top: -10px;\n              margin-bottom: 50px;\n              font-size: 28px;\n              font-weight: bold;\n            }\n            .fdn-modal-header span:hover,\n            .fdn-modal-header span:focus {\n              text-decoration: none;\n              cursor: pointer;\n            }\n            .fdn-modal-content {\n              width: 100%;\n              height: 100%;\n            }\n            @keyframes animatezoom {\n              from {\n                transform: scale(0.1);\n              }\n              to {\n                transform: scale(1);\n              }\n            }\n          ")));
    }
  };

  var Mobile = function Mobile(_ref) {
    var element_id = _ref.element_id,
        element_id_close = _ref.element_id_close,
        show = _ref.show,
        on_click = _ref.on_click,
        closable = _ref.closable,
        background_image = _ref.background_image,
        bottom = _ref.bottom,
        top = _ref.top,
        minHeight = _ref.minHeight,
        children = _ref.children;

    if (!show) {
      return null;
    } else {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "fdn-bg-filter-modal",
        onClick: closable ? on_click : function () {}
      }), /*#__PURE__*/React.createElement("div", {
        id: element_id,
        className: "fdn-modal"
      }, /*#__PURE__*/React.createElement("div", {
        className: "fdn-modal-header"
      }, closable && /*#__PURE__*/React.createElement("span", {
        id: element_id_close,
        onClick: closable ? on_click : function () {}
      }, "\xD7")), /*#__PURE__*/React.createElement("div", {
        className: "fdn-modal-content"
      }, children)), /*#__PURE__*/React.createElement("style", null, "\n            .fdn-bg-filter-modal {\n              display: block;\n              width: 100%;\n              height: 100%;\n              top: 0;\n              position: fixed;\n              background-color: rgb(0, 0, 0);\n              background-color: rgba(0, 0, 0, 0.4);\n              z-index: 998;\n            }\n            .fdn-modal {\n              position: fixed;\n              z-index: 999;\n              width: 90%;\n              min-height: ".concat(minHeight ? minHeight : "unset", ";\n              max-height: calc(100vh - 28px);\n              background-image: url(").concat(background_image, ");\n              background-color: #fff;\n              background-repeat: no-repeat;\n              background-size: cover;\n              padding: 10px;\n              border: 1px solid #888;\n              left: 50%;\n              top: ").concat(top ? top : "50%", ";\n              bottom: ").concat(bottom ? bottom : "unset", ";\n              margin-right: -50%;\n              transform: translate(-50%, -50%);\n              -webkit-animation-name: animatezoom;\n              -webkit-animation-duration: 0.4s;\n              animation-name: animatezoom;\n              animation-duration: 0.4s;\n            }\n            .fdn-modal-header {\n              position: relative;\n              width: 100%;\n              height: 15px;\n            }\n            .fdn-modal-header span {\n              position: absolute;\n              color: #000;\n              right: -5px;\n              top: -15px;\n              margin-bottom: 50px;\n              font-size: 25px;\n              font-weight: bold;\n            }\n            .fdn-modal-header span:hover,\n            .fdn-modal-header span:focus {\n              text-decoration: none;\n              cursor: pointer;\n            }\n            .fdn-modal-content {\n              width: 100%;\n              height: 100%;\n            }\n            @keyframes animatezoom {\n              from {\n                transform: scale(0.1);\n              }\n              to {\n                transform: scale(1);\n              }\n            }\n          ")));
    }
  };

  /**
   *
   * @param {String} props.element_id
   * @param {String} props.element_id_close
   * @param {Boolean} props.is_mobile
   * @param {Boolean} props.show
   * @param {Function} props.on_click
   * @param {Boolean} props.closable
   * @param {String} props.background_image
   * @param {String} props.width
   * @param {String} props.bottom
   * @param {String} props.top
   * @param {String <any>} props.children
   */

  var Modal = function Modal(_ref) {
    var element_id = _ref.element_id,
        element_id_close = _ref.element_id_close,
        is_mobile = _ref.is_mobile,
        show = _ref.show,
        on_click = _ref.on_click,
        closable = _ref.closable,
        background_image = _ref.background_image,
        width = _ref.width,
        bottom = _ref.bottom,
        top = _ref.top,
        minHeight = _ref.minHeight,
        children = _ref.children;
    var props = {
      element_id: element_id,
      element_id_close: element_id_close,
      is_mobile: is_mobile || false,
      show: show,
      on_click: on_click,
      closable: closable || false,
      background_image: background_image || 'https://s3-ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/completing-account-icon/bg-complete.png',
      width: width,
      bottom: bottom,
      minHeight: minHeight,
      top: top
    };

    if (is_mobile) {
      return /*#__PURE__*/React.createElement(Mobile, props, children);
    } else {
      return /*#__PURE__*/React.createElement(Desktop, props, children);
    }
  };

  return Modal;

})));
//# sourceMappingURL=modal.umd.js.map
